import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { handleApiError } from 'state/api';

export const getThirdPartyIntegrationsWithPaginationApi = createAsyncThunk(
  'thirdPartyIntegrations/getThirdPartyIntegrationsWithPagination',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `third-party-integrations?page=${page}&limit=${limit}`,
      );
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError(
        'getThirdPartyIntegrationsWithPaginationApi',
        error,
        rejectWithValue,
      );
    }
  },
);

export const getThirdPartyIntegrationApi = createAsyncThunk(
  'thirdPartyIntegrations/getThirdPartyIntegration',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`third-party-integrations/${id}`);
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getThirdPartyIntegrationApi', error, rejectWithValue);
    }
  },
);

export const updateThirdPartyIntegrationApi = createAsyncThunk(
  'thirdPartyIntegrations/updateThirdPartyIntegration',
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const response = await api.put(`third-party-integrations/${id}`, data);
      return response.data;
    } catch (error) {
      return handleApiError('updateThirdPartyIntegrationApi', error, rejectWithValue);
    }
  },
);

export const getThirdPartyIntegrationsListApi = createAsyncThunk(
  'thirdPartyIntegrations/getThirdPartyIntegrationsList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('third-party-integrations/list');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getThirdPartyIntegrationsListApi', error, rejectWithValue);
    }
  },
);

export const orderSupplierTaggingApi = createAsyncThunk(
  'thirdPartyIntegrations/orderSupplierTagging',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post('third-party-integrations/order-supplier-tagging');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('orderSupplierTaggingApi', error, rejectWithValue);
    }
  },
);

export const getShipStationTaggerScheduleApi = createAsyncThunk(
  'thirdPartyIntegrations/getShipStationTaggerSchedule',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('third-party-integration/ship-station/tagger-schedule');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getShipStationTaggerScheduleApi', error, rejectWithValue);
    }
  },
);

export const updateShipStationTaggerScheduleApi = createAsyncThunk(
  'thirdPartyIntegrations/updateShipStationTaggerSchedule',
  async (body, { rejectWithValue }) => {
    try {
      const response = await api.put(
        'third-party-integration/ship-station/tagger-schedule',
        body,
      );
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('updateShipStationTaggerScheduleApi', error, rejectWithValue);
    }
  },
);

export const getShipStationTaggerProcessStatusApi = createAsyncThunk(
  'thirdPartyIntegrations/getShipStationTaggerProcessStatus',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('third-party-integration/ship-station/process-status');
      return response.data.success ? response.data.data : response.data;
    } catch (error) {
      return handleApiError('getShipStationTaggerProcessStatusApi', error, rejectWithValue);
    }
  },
);

export const downloadShipStationTaggerRunReportCsvApi = createAsyncThunk(
  'thirdPartyIntegrations/downloadShipStationTaggerRunReportCsv',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        'third-party-integration/ship-station/run-report/download',
        { responseType: 'blob' },
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const stamp = new Date().toISOString().slice(0, 10);
      link.setAttribute('download', `ship-station-tagger-run-${stamp}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { downloaded: true };
    } catch (error) {
      return handleApiError(
        'downloadShipStationTaggerRunReportCsvApi',
        error,
        rejectWithValue,
      );
    }
  },
);

export const shipStationSalesOrderNumberMappingApi = createAsyncThunk(
  'thirdPartyIntegrations/shipStationSalesOrderNumberMapping',
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post(
        'third-party-integrations/shipstation-sales-order-number-mapping',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          // Bulk mapping performs one ShipStation lookup per row; allow long runs.
          timeout: 600000,
        },
      );

      return response.data;
    } catch (error) {
      return handleApiError(
        'shipStationSalesOrderNumberMappingApi',
        error,
        rejectWithValue,
      );
    }
  },
);
